import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import MoviesNFestsNew from '@components/partials/MoviesNFestsNew';
import useIsMobile from '../customHooks/useIsMobile';
import {
  useGetNowShowingQuery,
  useGetUpcomingQuery,
} from '@store/rtk/rtk.movieLists';

const SpecialScreening = () => {
  const { id } = useParams();
  const isMobile = useIsMobile();
  //   const navigate = useNavigate();

  const { data: todaysScreeningsMovies, isLoading: nowShowingLoading } =
    useGetNowShowingQuery({ limit: 1000, currentPage: 1 });

  // 🧠 Group movies by their label (Fan Show, Film Festival, etc.)
  const dynamicSections = useMemo(() => {
    if (!todaysScreeningsMovies?.data) return [];

    const labelMap = new Map();

    todaysScreeningsMovies.data
      ?.filter((movie) => movie.label_to_show?.length > 0)
      ?.forEach((movie) => {
        movie.label_to_show.forEach((labelItem) => {
          const labelName = labelItem.label || labelItem.label_name || '';
          if (!labelMap.has(labelName)) labelMap.set(labelName, []);
          labelMap.get(labelName).push(movie);
        });
      });

    return Array.from(labelMap.entries()).map(([label, movies], index) => ({
      id: index + 1,
      label,
      movies,
    }));
  }, [todaysScreeningsMovies]);

  // 🎯 Filter based on route param
  const visibleSections = useMemo(() => {
    if (!id) return dynamicSections;
    const section = dynamicSections.find((_, index) => index + 1 === Number(id));
    return section ? [section] : [];
  }, [id, dynamicSections]);

  // ⏳ Loading screen
  if (nowShowingLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          zIndex: 9999,
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{
            width: '4rem',
            height: '4rem',
            color: '#1b1c3c', // your brand color
          }}
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <section
      className={`  transition-all duration-300 ${
        isMobile ? 'pt-4 px-4' : 'pt-8 px-10'
      } bg-gradient-to-b from-gray-50 to-white`}
      style={{ overflowX: 'hidden' }}
    >
      {/* 🏷 Page Title */}
      <div className={`text-center ${isMobile ? 'mt-2' : 'mt-5'}`}>
        <h1
          className={`font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#1f1c3c] to-[#7b6cf6] ${
            isMobile ? 'text-2xl' : 'text-4xl'
          }`}
        >
          🎥 Special Screenings
        </h1>
        <p className="text-gray-600 mt-2">
          Explore exclusive movie events and themed shows
        </p>
      </div>

      {/* No Sections */}
      {visibleSections.length === 0 ? (
        <div className="text-center my-16">
          <h5 className="text-lg font-medium text-gray-500">
            No Special Screenings Found
          </h5>
        </div>
      ) : (
        visibleSections.map((section) => (
          <div
            key={section.id}
            className={`container-fluid container-xl rounded-2xl shadow-md mb-12 transition-transform hover:scale-[1.01] ${
              isMobile ? 'p-3' : 'p-6'
            } `}
          >
            {/* Section Header */}
            <div
              className="flex justify-between items-center border-b border-gray-200 pt-3 "
              style={{
                color: '#1f1c3c',
              }}
            >
              <div class="divider">
                <h2
                  className={`font-bold tracking-wide text-center ${
                    isMobile ? 'text-lg' : 'text-2xl'
                  }`}
                >
                  {section.label}
                </h2>
              </div>

              {/* View section button */}
              {/* <button
                onClick={() => navigate(`/special-screening/${section.id}`)}
                className="text-sm font-semibold text-[#7b6cf6] hover:text-[#1f1c3c] transition-all"
              >
                View Only
              </button> */}
            </div>

            {/* Section Movies */}
            {section.movies?.length > 0 ? (
              <MoviesNFestsNew
                section={section.id}
                moviesArray={section.movies}
                subCategory=""
                category={section.label}
                movieCount={section.movies.length}
                type="now_showing"
                slider={!isMobile}
                showMovieList={{ category_id: 1 }}
              />
            ) : (
              <div className="text-center py-5 text-gray-500 font-medium">
                No Movies Found
              </div>
            )}
          </div>
        ))
      )}
    </section>
  );
};

export default SpecialScreening;
